import { createFileRoute } from "@tanstack/react-router"
import { RoleDetailPage } from "@/components/rema/roles"

function RoleDetailRoute() {
  const { roleNumber } = Route.useParams()
  return (
    <div className="p-6">
      <RoleDetailPage roleNumber={roleNumber} />
    </div>
  )
}

export const Route = createFileRoute("/rema/roles/$roleNumber")({
  staticData: {
    title: 'Role Detail',
    isSecured: true,
  },
  component: RoleDetailRoute,
})
